import type { Transport, UserTrack } from '@/core/Transport'

declare global {
  interface Window {
    dataLayer: Array<unknown>
  }
}

export class Ga4TransportAdapter implements Transport {
  track(event: string, context: Record<string, unknown>) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!window.dataLayer) return

    window.dataLayer.push({ ...context, event })
  }

  page(context: Record<string, unknown>, extras?: Record<string, unknown>) {
    this.track('page_view_ga4', {
      page_location: context.location,
      page_path: context.path,
      page_title: context.title,
      ...extras,
    })
  }

  identify(user: UserTrack) {
    this.track('identify', { user_id: user.userId })
  }
}
